import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import cn from 'classnames'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import Accordion from '@groovehq/internal-design-system/lib/components/Accordion/Accordion'
import {
  selectReportingPermitted,
  selectCurrentUserIsAdminOrOwner,
} from 'ducks/currentUser'
import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import { selectCurrentPage } from 'selectors/location'
import { selectSettingsLandingPageAction } from 'selectors/menus'
import { LANDING_PAGE as KB_LANDING_PAGE } from 'subapps/kb/pages'
import { doOpenMainPage } from 'actions/pages'
import { selectShouldHideNewSettings } from 'ducks/flags'
import CentralizeSectionMenu from '../Nav/CentralizeSection/Menu'
import AnalyzeSectionMenu from '../Nav/AnalyzeSection/Menu'
import IntegrationsSectionMenu from '../Nav/IntegrationsSection/Menu'
import { useAccessIntegration } from '../useAccessIntegration'
import { styles } from './styles'
import Item from '../Nav/Item'

const toMainPage = doOpenMainPage()

const AccordionNav = ({ active, setOpen }) => {
  const showReporting = useSelector(selectReportingPermitted)
  const settingsLandingPageAction = useSelector(selectSettingsLandingPageAction)
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const shouldHideNewSettings = useSelector(selectShouldHideNewSettings)

  const settingsActive =
    useSelector(selectCurrentPage) !== SETTINGS_INTEGRATIONS_PAGE &&
    active === 'Settings'
  const integrationsActive =
    useSelector(selectCurrentPage) === SETTINGS_INTEGRATIONS_PAGE

  const handleCloseMenu = useCallback(
    () => {
      setOpen(false)
    },
    [setOpen]
  )

  const handleClickIntegration = useAccessIntegration(handleCloseMenu)

  return (
    <Accordion css={styles.accordionNav}>
      <Accordion.Panel
        panelKey={'centralizeSection'}
        onClickItem={!isManager ? handleCloseMenu : undefined}
        title={
          <div
            css={text.styles.textXs}
            className={cn(active === 'Conversations' && 'active')}
          >
            {isManager ? (
              'Conversations'
            ) : (
              <Item
                to={toMainPage}
                onClick={handleCloseMenu}
                className="grui p-0 m-0"
              >
                Conversations
              </Item>
            )}
          </div>
        }
        css={!isManager && styles.accordionPanelLink}
      >
        {isManager && <CentralizeSectionMenu onClose={handleCloseMenu} />}
      </Accordion.Panel>
      {showReporting && (
        <Accordion.Panel
          panelKey={'reports'}
          title={
            <div
              css={text.styles.textXs}
              className={cn(active === 'Reporting' && 'active')}
            >
              Reports
            </div>
          }
        >
          <AnalyzeSectionMenu onClose={handleCloseMenu} />
        </Accordion.Panel>
      )}
      <Accordion.Panel
        panelKey={'knowledge'}
        onClickItem={handleCloseMenu}
        title={
          <Item
            css={text.styles.textXs}
            isActive={active === 'Knowledge Base'}
            to={{ type: KB_LANDING_PAGE }}
            className="grui p-0 m-0"
          >
            Knowledge Base
          </Item>
        }
        css={styles.accordionPanelLink}
      />
      <Accordion.Panel
        panelKey={'apps'}
        title={
          <div
            css={text.styles.textXs}
            className={cn(integrationsActive && 'active')}
          >
            Apps
          </div>
        }
      >
        <IntegrationsSectionMenu
          onClose={handleCloseMenu}
          handleClickIntegration={handleClickIntegration}
        />
      </Accordion.Panel>
      <Accordion.Panel
        panelKey={'settings'}
        onClickItem={handleCloseMenu}
        title={
          <Item
            css={text.styles.textXs}
            isActive={settingsActive}
            to={settingsLandingPageAction}
            className="grui p-0 m-0"
            isNew={shouldHideNewSettings === false}
          >
            Settings
          </Item>
        }
        css={styles.accordionPanelLink}
      />
    </Accordion>
  )
}

export default AccordionNav
